<script>
import Vue from 'vue'

function RenderComponent(template) {
  const renderer = Vue.compile(template)
  return {
    render: renderer.render,
    staticRenderFns: renderer.staticRenderFns,
  }
}

export default {
  name: 'Renderer',
  props: ['result', 'dataRes'],
  data() {
    return {
      component: '',
      False: false,
      True: true,
      None: undefined,
    }
  },
  watch: {
    result: {
      handler(nval) {
        // console.log(nval)
      /* eslint-disable no-lonely-if */
        if (nval) {
          if ('object' === typeof nval) {
            this.component = nval.val
          } else {
            if (-1 === window.location.href.indexOf('favorites')) {
              this.component = RenderComponent(nval)
            } else {
              this.component = RenderComponent(`<div class="row row-for-help">${nval}</div>`)
            }
          }
        }
      },
      immediate: true,
    },
  },

  render(h) {
    if ('object' === typeof this.result) {
      if (this.dataRes) {
        return h(
          'component', { is: this.component, props: { dataResult: this.dataRes } }
        )
      }
      return h('div', this.$slots.default)
    }
    if (this.result) {
      return h(
        'component', {
          is: this.component,
          on: {
            renderer: event => {
              this.$emit('renderer-event', event)
            },
          },
        }
      )
    }
    return h('div', this.$slots.default)
  },
}

</script>
